import { PaletteMode } from "@mui/material";

const KEY = "partner_portal_";

const canUseStorage = (): boolean => {
  if (
    typeof window === "undefined" ||
    typeof window.localStorage === "undefined"
  )
    return false;
  try {
    window.localStorage.setItem("__t", "1");
    window.localStorage.removeItem("__t");
    return true;
  } catch {
    return false;
  }
};

const storage = {
  getMode(): PaletteMode | null {
    if (!canUseStorage()) return null;
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PaletteMode;
    } catch {
      return (raw as PaletteMode) ?? null;
    }
  },
  setMode(mode: PaletteMode) {
    if (!canUseStorage()) return;
    window.localStorage.setItem(KEY, JSON.stringify(mode));
  },
  clearMode() {
    if (!canUseStorage()) return;
    window.localStorage.removeItem(KEY);
  },
};

export default storage;
